<div class="with-floating-button">
    <div class="content">
        <page-header
                *ngIf="isDisplayed"
                [title]="'workflow.statuts.title' | translate"
                [listeItems]="listeTabItems"
                [selectedIndex]="selectedIndex"
                (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>

        <router-outlet></router-outlet>
    </div>
</div>
